// Wrapper of the MultiSelect component with added functionality to refine search
// results on option select

import React from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import PropTypes from "prop-types";

import promoAttributeReference from "components/search/references/promoAttributeReference";
import FilterPromoContext from "components/search/context/FilterPromoContext";
import MultiSelect from "components/shared/MultiSelect";

const propTypes = {
  attribute: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  className: PropTypes.string,
  currentRefinement: PropTypes.array,
  id: PropTypes.string.isRequired,
  isAPlus: PropTypes.bool,
  items: PropTypes.array,
  name: PropTypes.string.isRequired,
  refine: PropTypes.func.isRequired,

  //
  // Filter promo context props
  setCurrentPromoAttribute: PropTypes.func.isRequired,
  title: PropTypes.string
};

const defaultProps = {
  className: "",
  isAPlus: false,
  items: [],
  title: null
};

const MultiSelectRefinementList = (props) => {
  const handleRefine = (selectedValues) => {
    if (!props.isAPlus) {
      props.setCurrentPromoAttribute(promoAttributeReference[props.attribute]);
      return;
    }

    props.refine((selectedValues || []).map(({ value }) => value));
  };

  const refinementClassName = `refinement-list ${props.className}`;

  const countedCategories = props.categories.map((cat) => {
    const { count } = props.items.find((i) => i.label === cat.value) || {
      count: 0
    };
    return { ...cat, numResults: count };
  });

  return (
    <div className={refinementClassName}>
      {props.title && <div>{props.title}</div>}
      <MultiSelect
        id={props.id}
        isControlled
        name={props.name}
        onChange={handleRefine}
        options={countedCategories}
        preventSelect={!props.isAPlus}
        value={props.currentRefinement}
      />
    </div>
  );
};

const MultiSelectRefinementListWithContext = (props) => {
  return (
    <FilterPromoContext.Consumer>
      {(filterPromoContextProps) => (
        <MultiSelectRefinementList {...props} {...filterPromoContextProps} />
      )}
    </FilterPromoContext.Consumer>
  );
};

MultiSelectRefinementList.propTypes = propTypes;
MultiSelectRefinementList.defaultProps = defaultProps;

export default connectRefinementList(MultiSelectRefinementListWithContext);
